import type { RouteObject } from 'react-router';

import * as cmsViewFileHorizonRouteExports from '#/modules/cms/files/pages/view/CmsViewFile.horizon-route';
import { cmsViewFileRoute } from '#/modules/cms/files/routing/cmsFiles.routes';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

export const cmsFilesRouteObjects = [
  {
    path: cmsViewFileRoute.fullPath,
    ...horizonRouteToObject(cmsViewFileHorizonRouteExports),
  },
] satisfies RouteObject[];
